// 营销邮件管理 (FBMPLAY-1231) i18n — 6 个命名空间合并
export default {
  emailSenders: {
    tab: { senders: 'Senders' },
    title: 'Email Sender Management',
  
    // Query form
    form: {
      channelEmpty: 'No sending domain configured yet, please add one under Sending Domain / Channel',
      bussType: 'Business Type',
      bussTypePlaceholder: 'Please select business type',
      channel: 'Channel',
      channelPlaceholder: 'Please select channel',
      fromEmail: 'Sender Email',
      fromEmailPlaceholder: 'Please enter sender email',
      fromEmailPrefixPlaceholder: 'Enter the part before @',
      domainPending: 'Select a sending domain first',
      fromName: 'From Name',
      fromNamePlaceholder: 'Please enter From Name',
      status: 'Status',
      statusPlaceholder: 'Please select status'
    },
  
    // Table columns
    table: {
      index: 'No.',
      fromName: 'From Name',
      bussType: 'Business Type',
      fromEmail: 'From Email',
      channel: 'Channel',
      lastOperator: 'Last Operator / Time',
      status: 'Status',
      actions: 'Actions'
    },
  
    // Business type
    bussType: {
      marketing: 'Marketing',
      notification: 'Notification'
    },
  
    // Channel
    channel: {
      notConfigured: 'No domain',
      mailgunApi: 'Mailgun API'
    },
  
    // Status
    status: {
      enabled: 'Enabled',
      disabled: 'Disabled'
    },
  
    // Buttons
    button: {
      search: 'Search',
      reset: 'Reset',
      create: 'Add',
      edit: 'Edit',
      delete: 'Delete'
    },
  
    // Modal
    modal: {
      createTitle: 'Add Sender',
      editTitle: 'Edit Sender'
    },
  
    // Validation
    validation: {
      domainMismatch: 'The From Email domain ({{emailDomain}}) does not match the selected sending domain ({{channelDomain}})',
      domainNotConfigured: 'Domain {{domain}} has no channel / key configured yet, please add it under Sending Domain / Channel',
      bussTypeRequired: 'Please select business type',
      channelRequired: 'Please select channel',
      fromEmailRequired: 'Please enter sender email',
      fromEmailInvalid: 'Please enter a valid email address',
      fromEmailPrefixRequired: 'Please enter the mailbox prefix',
      fromEmailPrefixInvalid: 'Prefix may only contain letters, digits and common symbols such as . _ - +',
      fromNameRequired: 'Please enter From Name',
      statusRequired: 'Please select status'
    },
  
    // Confirm
    confirm: {
      enable: 'Are you sure you want to enable this sender?',
      disable: 'Are you sure you want to disable this sender?',
      delete: 'Are you sure you want to delete this sender?',
      okText: 'OK',
      cancelText: 'Cancel'
    },
  
    // Messages
    message: {
      queryFailed: 'Query failed',
      createSuccess: 'Created successfully',
      createFailed: 'Failed to create',
      updateSuccess: 'Updated successfully',
      updateFailed: 'Failed to update',
      deleteSuccess: 'Deleted successfully',
      deleteFailed: 'Failed to delete',
      statusUpdateSuccess: 'Status updated successfully',
      statusUpdateFailed: 'Failed to update status'
    }
  },
  emailTemplates: {
    title: 'Email Templates',
  
    loadingMore: 'Loading...',
    copySuffix: '-Copy',
  
    // Form
    form: {
      tempName: 'Template Name',
      tempNamePlaceholder: 'Please enter template name',
      country: 'Region',
      countryPlaceholder: 'Please select region',
      category: 'Category',
      categoryPlaceholder: 'Please select category',
      bussType: 'Business Type',
      bussTypePlaceholder: 'Please select business type',
      fromEmail: 'Sender',
      fromEmailPlaceholder: 'Please select sender',
      tempTitle: 'Email Subject',
      tempTitlePlaceholder: 'Please enter email subject',
      status: 'Status',
      statusPlaceholder: 'Please select status',
      content: 'Email Body',
      contentPlaceholder: 'Please enter email body (HTML supported). Variable: {{memberAccount}}'
    },
  
    bussType: {
      marketing: 'Marketing',
      notification: 'Notification'
    },
  
    table: {
      tempId: 'Template ID',
      tempName: 'Template Name',
      bussType: 'Type',
      country: 'Region',
      category: 'Category',
      tempTitle: 'Email Subject',
      lastOperate: 'Last Operator / Time',
      status: 'Status',
      actions: 'Actions'
    },
  
    status: {
      enabled: 'Enabled',
      disabled: 'Disabled'
    },
  
    button: {
      create: 'New Template',
      copy: 'Copy',
      test: 'Test Send'
    },
  
    modal: {
      createTitle: 'New Email Template',
      editTitle: 'Edit Email Template'
    },
  
    variables: {
      example: 'e.g.',
      group: { COMMON: 'Common', TRANSACTION: 'Transaction', ACTIVITY: 'Promotion' },
      title: 'Supported Variables',
      tip: 'Click a variable to insert it into the email body',
      memberAccount: 'Member Account'
    },
  
    validation: {
      tempNameRequired: 'Please enter template name',
      countryRequired: 'Please select region',
      categoryRequired: 'Please select category',
      bussTypeRequired: 'Please select business type',
      fromEmailRequired: 'Please select sender',
      tempTitleRequired: 'Please enter email subject',
      contentRequired: 'Please enter email body',
      statusRequired: 'Please select status'
    },
  
    message: {
      queryFailed: 'Query failed',
      createSuccess: 'Created successfully',
      createFailed: 'Create failed',
      updateSuccess: 'Updated successfully',
      updateFailed: 'Update failed',
      deleteSuccess: 'Deleted successfully',
      deleteFailed: 'Delete failed',
      copySuccess: 'Copied successfully',
      copyFailed: 'Copy failed',
      statusUpdateSuccess: 'Status updated successfully',
      statusUpdateFailed: 'Status update failed'
    },
  
    confirm: {
      delete: 'Are you sure you want to delete this template?',
      toggleStatus: 'Are you sure you want to toggle the status of this template?'
    },
  
    pagination: {
      total: 'Total {{total}} records'
    },
  
    test: {
      title: 'Test Send Email',
      templateName: 'Template Name',
      templateTitle: 'Email Subject',
      templateContent: 'Email Body',
      inputLabel: 'Recipient',
      inputPlaceholder: 'Please enter email address or member account',
      inputHint: 'The system will automatically detect whether the input is an email address or a member account',
      send: 'Send',
      inputRequired: 'Please enter email address or member account',
      success: 'Test send succeeded',
      failed: 'Test send failed',
      error: 'Test send error',
      userNotFound: 'Test user not found in the system'
    },
  
    category: {
      modal: {
        title: 'Template Category Management'
      },
      table: {
        id: 'ID',
        name: 'Category Name',
        actions: 'Actions'
      },
      form: {
        namePlaceholder: 'Please enter category name'
      },
      button: {
        create: 'New Category'
      },
      confirm: {
        delete: 'Are you sure you want to delete this category?',
        deleteDesc: 'This action cannot be undone, please proceed with caution'
      },
      allCategories: 'All Categories',
      nameRequired: 'Please enter category name',
      nameExists: 'Category name already exists',
      queryFailed: 'Failed to query categories',
      createSuccess: 'Category created successfully',
      createFailed: 'Failed to create category',
      deleteSuccess: 'Category deleted successfully',
      deleteFailed: 'Failed to delete category'
    }
  },
  emailTasks: {
    title: 'Bulk Email',
  
    button: {
      createInternalCampaign: 'New Internal-User Campaign',
      createExternalCampaign: 'New External-User Campaign',
      view: 'View',
      edit: 'Edit',
      delete: 'Delete',
      sendNow: 'Send Now',
      uploadFile: 'Upload File',
      importLog: 'Import Log',
      reset: 'Reset'
    },
  
    form: {
      taskName: 'Task Name',
      taskNamePlaceholder: 'Enter task name',
      operator: 'Operator',
      operatorPlaceholder: 'Enter operator',
      region: 'Region',
      regionPlaceholder: 'Select region',
      status: 'Status',
      statusPlaceholder: 'Select status',
      sendTime: 'Send Time',
      mode: 'Mode',
      modeFilter: 'Bulk Send (by filter)',
      modeImport: 'Import Usernames (upload CSV)',
      category: 'Category',
      categoryPlaceholder: 'Select category',
      template: 'Email Template',
      templatePlaceholder: 'Select email template',
      agent: 'Agent Name',
      agentPlaceholder: 'Select agent',
      fromEmail: 'From',
      fromEmailPlaceholder: 'Auto-filled after selecting template',
      templateContent: 'Template Content',
      templateContentPlaceholder: 'Auto-filled after selecting template',
      trackStatus: 'Enable open/click tracking',
      uploadEmailList: 'Upload Email List',
      chooseFile: 'Choose File',
      uploaded: 'Uploaded'
    },
  
    table: {
      taskName: 'Task Name',
      template: 'Template',
      region: 'Region',
      operator: 'Operator',
      createTime: 'Created At',
      sendTime: 'Send Time',
      actions: 'Actions'
    },
  
    status: {
      pendingUpload: 'Pending List Upload',
      pendingSend: 'Pending Send',
      ready: 'List Ready',
      completed: 'Completed',
      sent: 'Sent'
    },
  
    confirm: {
      delete: 'Are you sure you want to delete this task?',
      send: 'Are you sure you want to send now?'
    },
  
    validation: {
      taskNameRequired: 'Please enter task name',
      regionRequired: 'Please select region',
      categoryRequired: 'Please select category',
      templateRequired: 'Please select email template',
      agentRequired: 'Please select agent'
    },
  
    message: {
      queryFailed: 'Query failed',
      createSuccess: 'Created successfully',
      createFailed: 'Create failed',
      updateSuccess: 'Updated successfully',
      updateFailed: 'Update failed',
      deleteSuccess: 'Deleted successfully',
      deleteFailed: 'Delete failed',
      sendSuccess: 'Sent successfully',
      sendFailed: 'Send failed'
    },
  
    upload: {
      success: 'Upload succeeded',
      failed: 'Upload failed',
      error: 'Upload error: {error}',
      invalidFileType: 'Unsupported file type, please upload Excel or CSV',
      pleaseUploadFirst: 'Please upload the list file first'
    },
  
    modal: {
      createTitle: 'New Bulk Email',
      editTitle: 'Edit Bulk Email',
      viewTitle: 'View Bulk Email',
      importLogTitle: 'Import Log',
      close: 'Close'
    },
  
    importLog: {
      result: { excluded: 'Excluded', failed: 'Failed', excludedReason: 'Unsubscribed, will not be sent' },
      loading: 'Loading...',
      header: {
        taskName: 'Task Name',
        operator: 'Operator',
        importFileName: 'Import File Name',
        importCompleteTime: 'Import Completed At',
        importStatus: 'Import Status'
      },
      stats: {
        excluded: 'Excluded (unsubscribed)',
        success: 'Imported',
        failed: 'Failed',
        total: 'Total'
      },
      failureDetails: {
        result: 'Result',
        title: 'Failure Details',
        target: 'Recipient',
        failureReason: 'Failure Reason',
        noFailedRecords: 'No failed records',
        noImportRecords: 'No import records yet'
      },
      uploadFileStatus: {
        '0': 'Processing',
        '1': 'Completed',
        '2': 'Failed'
      }
    },
  
    pagination: {
      total: 'Total {total}'
    }
  },
  emailLogs: {
    title: 'Email Send Logs',
  
    // Form related
    form: {
      sendTime: 'Send Time',
      sendTimePlaceholder: 'Please select send time',
      startDate: 'Start Date',
      endDate: 'End Date',
      region: 'Region',
      regionPlaceholder: 'Please select region',
      task: 'Task Name',
      taskPlaceholder: 'Please enter task name',
      subTypePlaceholder: 'Please select sub type / member type',
      subTypeMemberGroup: 'Member Type',
      taskType: 'Send Type',
      taskTypePlaceholder: 'Please select send type',
      bussType: 'Business Type',
      bussTypePlaceholder: 'Please select business type',
      account: 'Member Account / Email',
      accountPlaceholder: 'Please enter member account or email',
      status: 'Status',
      statusPlaceholder: 'Please select status'
    },
  
    // Table related
    table: {
      time: 'Send Time',
      task: 'Task Name',
      region: 'Region',
      type: 'Type',
      user: 'Member Account',
      email: 'Email',
      status: 'Status',
      openTime: 'Opened',
      remark: 'Failure Reason'
    },
  
    // Business type
    type: {
      bulk: 'Bulk',
      ndc: 'New Customer',
      inactive: 'Inactive',
      churn: 'Churn',
      vip: 'VIP',
      welcome: 'Welcome',
      restorage: 'Re-deposit'
    },
  
    // Status related
    status: {
      submitted: 'Submitted',
      accepted: 'Submitted',
      delivered: 'Delivered',
      opened: 'Opened',
      failed: 'Failed',
      unsubscribed: 'Unsubscribed',
      complained: 'Complained',
      unknown: 'Unknown'
    },
  
    // Export related
    export: {
      button: 'Export',
      loading: 'Export task created. Check progress in download list.',
      noData: 'No data to export',
      tooMany: 'Maximum 100,000 records per export. Please narrow your filters.'
    },
  
    // Message related
    message: {
      queryFailed: 'Query failed',
      exportSuccess: 'Export successful',
      exportFailed: 'Export failed'
    },
  
    // Pagination related
    pagination: {
      total: 'Total {{total}} records'
    }
  },
  emailReport: {
    // Page title
    title: 'Send Report',
    subtitle: 'Email send statistics and analytics report',
  
    // Form fields
    form: {
      startTime: 'Start Time',
      startTimeRequired: 'Please select start time',
      startTimePlaceholder: 'Select start time',
      endTime: 'End Time',
      endTimeRequired: 'Please select end time',
      endTimePlaceholder: 'Select end time',
      taskName: 'Task Name',
      taskNamePlaceholder: 'Enter task name',
      channel: 'Channel',
      channelPlaceholder: 'Select channel',
      status: 'Status',
      statusPlaceholder: 'Select status',
      region: 'Region',
      regionPlaceholder: 'Select region'
    },
  
    // Task status
    status: {
      pending: 'Pending',
      sending: 'Sending',
      completed: 'Completed'
    },
  
    // Channel
    channel: {
      mailgunApi: 'Mailgun API'
    },
  
    // Region
    region: {
      ph: 'PH - Philippines',
      vn: 'VN - Vietnam',
      th: 'TH - Thailand',
      cn: 'CN - China'
    },
  
    // Buttons
    button: {
      search: 'Search',
      reset: 'Reset',
      export: 'Export'
    },
  
    // Table columns
    table: {
      date: 'Date',
      task: 'Task Name',
      targetCount: 'Target',
      sendCount: 'Submitted',
      deliveredCount: 'Delivered',
      failedCount: 'Failed',
      openedCount: 'Opened',
      actions: 'Actions',
      viewLogs: 'View Logs'
    },
  
    // Logs modal
    logs: {
      title: 'Send Logs',
      time: 'Time',
      task: 'Task',
      user: 'User',
      email: 'Email',
      channel: 'Channel',
      status: 'Status',
      remark: 'Remark',
      statusPending: 'Pending',
      statusSuccess: 'Success',
      statusFailed: 'Failed',
      statusUnknown: 'Unknown'
    },
  
    // Messages
    message: {
      selectTimeRange: 'Please select start and end time',
      exportSuccess: 'Export succeeded',
      exportFailed: 'Export failed',
      exporting: 'Exporting data...',
      queryFailed: 'Query failed',
      noData: 'No data'
    },
  
    // Pagination
    pagination: {
      total: 'Total {total} records'
    }
  },
  emailUnsubscribe: {
    title: 'Unsubscribe List',
  
    // Form / filters
    form: {
      unsubscribeTime: 'Unsubscribe Time',
      startDate: 'Start Date',
      endDate: 'End Date',
      emailAddress: 'Email Address',
      emailAddressPlaceholder: 'Please enter email address',
      memberAccount: 'Member Account',
      memberAccountPlaceholder: 'Please enter member account',
      originType: 'Source',
      originTypePlaceholder: 'Please select source',
      reason: 'Reason',
      reasonPlaceholder: 'Please select reason',
      remark: 'Remark',
      remarkPlaceholder: 'Please enter remark',
      search: 'Search',
      reset: 'Reset'
    },
  
    // Table
    table: {
      nonMember: 'Non-member',
      unsubscribeTime: 'Unsubscribe Time',
      emailAddress: 'Email Address',
      memberAccount: 'Member Account',
      originType: 'Source',
      remark: 'Remark',
      actions: 'Actions'
    },
  
    // Origin type
    originType: {
      all: 'All',
      selfUnsubscribe: 'Self Unsubscribe (Link)',
      complaint: 'Complaint / Request',
      manual: 'Manually Added by Support'
    },
  
    // Add modal
    add: {
      mode: 'Unsubscribe by',
      modeMember: 'Member account',
      modeEmail: 'Email address',
      modeEmailHint: 'For non-members / complaints and other fallback cases',
      lookupEmail: 'Look up email',
      validEmail: 'Verified email (auto-filled, masked, read-only)',
      validEmailPlaceholder: 'Auto-filled after looking up the member account',
      button: 'Add Unsubscribe',
      title: 'Add Unsubscribe',
      okText: 'OK',
      cancelText: 'Cancel'
    },
  
    // Delete
    delete: {
      button: 'Delete',
      confirm: 'Are you sure you want to delete this unsubscribe record?',
      okText: 'OK',
      cancelText: 'Cancel',
      complaintBlocked: 'Complaint / Request unsubscribe records cannot be deleted. Only records manually added by support can be deleted.'
    },
  
    // Validation
    validation: {
      memberAccountRequired: 'Please enter the member account',
      lookupFirst: 'Please click "Look up email" first to confirm the member\'s verified email',
      emailAddressRequired: 'Please enter email address',
      emailAddressInvalid: 'Please enter a valid email address',
      reasonRequired: 'Please select reason'
    },
  
    // Messages
    message: {
      lookupFailed: 'Failed to look up the member\'s email',
      queryFailed: 'Query failed',
      addSuccess: 'Added successfully',
      addFailed: 'Failed to add',
      deleteSuccess: 'Deleted successfully',
      deleteFailed: 'Failed to delete'
    }
  },
  emailAutoPushConfig: {
    title: 'Auto Email Configuration',

    searchForm: {
      language: 'Language',
      languagePlaceholder: 'Please select language',
      bussType: 'Business Type',
      bussTypePlaceholder: 'Please select business type',
      aimType: 'Target Type',
      aimTypePlaceholder: 'Please select target type',
      subPushType: 'Sub Type',
      subPushTypePlaceholder: 'Please select sub type',
      memberType: 'Member Type',
      memberTypePlaceholder: 'Please select member type',
      status: 'Status',
      statusPlaceholder: 'Please select status',
      search: 'Search',
      reset: 'Reset',
      add: 'Add Rule'
    },

    table: {
      language: 'Language',
      aimType: 'Target Type',
      subTypeOrMember: 'Sub Type / Member Type',
      ruleName: 'Rule Name',
      template: 'Template',
      status: 'Status',
      operation: 'Operation',
      edit: 'Edit'
    },

    aimType: {
      scene: 'Scene Trigger',
      target: 'Target User'
    },

    pushSwitch: {
      enabled: 'Enabled',
      disabled: 'Disabled'
    },

    confirm: {
      enable: 'Are you sure you want to enable this rule?',
      disable: 'Are you sure you want to disable this rule?',
      okText: 'Confirm',
      cancelText: 'Cancel'
    },

    modal: {
      addTitle: 'Add Auto Email Rule',
      editTitle: 'Edit Auto Email Rule',
      baseInfoTitle: 'Basic Information',
      ruleName: 'Rule Name',
      ruleNamePlaceholder: 'Please enter rule name',
      language: 'Language',
      languagePlaceholder: 'Please select language',
      aimType: 'Target Type',
      pushType: 'Trigger Event',
      pushTypePlaceholder: 'Please select trigger event',
      subPushType: 'Sub Type',
      subPushTypePlaceholder: 'Please select sub type',
      loginChannel: 'Login Channel',
      loginChannelPlaceholder: 'Please select login channel',
      memberType: 'Member Type',
      memberTypePlaceholder: 'Please select member type',
      sendTime: 'Send Time',
      sendTimePlaceholder: 'Please enter send time',
      sendTimePlaceholderDay: 'Please enter number of days',
      sendTimePlaceholderWeek: 'Please enter 1-7 (1=Monday, 7=Sunday)',
      sendTimePlaceholderMonth: 'Please enter 1-31 (day of month)',
      sendTimeUnit: 'Time Unit',
      status: 'Status',
      enable: 'Enable',
      disable: 'Disable',
      emailContentTitle: 'Email Content',
      bussType: 'Business Type',
      bussTypePlaceholder: 'Please select business type',
      tempClassify: 'Template Category',
      tempClassifyPlaceholder: 'Please select template category',
      template: 'Select Template',
      templatePlaceholder: 'Please select template',
      preview: {
        fromEmail: 'From Email',
        tempTitle: 'Email Subject',
        tempContent: 'Email Content'
      }
    },

    validation: {
      ruleNameRequired: 'Please enter rule name',
      languageRequired: 'Please select language',
      subPushTypeRequired: 'Please select sub type',
      sendTimeRequired: 'Please enter send time',
      sendTimeUnitRequired: 'Please select time unit',
      sendTimeRange: 'Send time must be between {{min}} and {{max}}',
      tempClassifyRequired: 'Please select template category',
      templateRequired: 'Please select template',
      depositNumberRequired: 'Please enter deposit order'
    },

    messages: {
      fetchDataFailed: 'Failed to fetch data',
      addSuccess: 'Added successfully',
      addFailed: 'Failed to add',
      updateSuccess: 'Updated successfully',
      updateFailed: 'Failed to update',
      confirmDelete: 'Confirm delete',
      deleteSuccess: 'Deleted successfully',
      deleteFailed: 'Failed to delete',
      statusUpdateSuccess: 'Status updated successfully',
      statusUpdateFailed: 'Failed to update status'
    }
  },
  // 发信域名 / 渠道（FBMPLAY-1595 多域名多 Key，发件人管理页 Admin-only Tab）
  emailChannels: {
    title: 'Sending Domain / Channel',

    tab: {
      channels: 'Sending Domain',
    },

    hint: {
      perDomainKey: 'One Sending API Key per domain (multiple supported); senders belong to a domain and share its key.'
    },

    table: {
      sendDomain: 'Sending domain',
      region: 'Region',
      apiKey: 'Sending API Key',
      apiKeyMissing: 'Not configured',
      status: 'Status',
      lastOperator: 'Last operator / time',
      actions: 'Actions'
    },

    form: {
      sendDomain: 'Sending domain',
      sendDomainPlaceholder: 'e.g. mail.newbrand.com',
      region: 'Region',
      apiKey: 'Sending API Key',
      apiKeyPlaceholder: 'Paste the Mailgun sending API key for this domain',
      apiKeyHint: 'Write-only; after saving only the last 4 characters are shown',
      apiKeyEditHint: 'Leave empty to keep the current key (key-••••••••{{tail}}); fill in to replace it',
      status: 'Status'
    },

    status: {
      enabled: 'Enabled',
      disabled: 'Disabled'
    },

    button: {
      create: 'Add domain',
      edit: 'Edit',
      delete: 'Delete',
      replaceKey: 'Replace key',
      testConnection: 'Test connection',
      testing: 'Testing...',
      save: 'Save',
      cancel: 'Cancel'
    },

    modal: {
      createTitle: 'Add sending domain',
      editTitle: 'Edit sending domain',
      replaceKeyTitle: 'Replace Sending API Key'
    },

    validation: {
      sendDomainRequired: 'Please enter the sending domain',
      sendDomainInvalid: 'Please enter a valid domain, e.g. mail.newbrand.com',
      regionRequired: 'Please select a region',
      apiKeyRequired: 'Please enter the Sending API Key'
    },

    confirm: {
      delete: 'Delete this sending domain?',
      enable: 'Enable this sending domain?',
      disable: 'Disable this sending domain? Senders under it will not be able to send.',
      okText: 'OK',
      cancelText: 'Cancel'
    },

    message: {
      queryFailed: 'Query failed',
      createSuccess: 'Created successfully',
      createFailed: 'Failed to create',
      updateSuccess: 'Updated successfully',
      updateFailed: 'Failed to update',
      deleteSuccess: 'Deleted successfully',
      deleteFailed: 'Failed to delete',
      statusUpdateSuccess: 'Status updated successfully',
      statusUpdateFailed: 'Failed to update status',
      testSuccess: 'Connection successful (verified by the backend; the key is never returned)',
      testFailed: 'Connection failed, please check the domain, region and API key'
    }
  },
};
